// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Marktinformationen`,
    h229e7d06093c2f3f: html `ESG und Diversität`,
    h4b6568de605796be: html `Boards &amp; Governance`,
    h4e84df3b11ed9b4f: html `Hilfe und Support`,
    h722c4148bfbe6706: html `Bildung und Zertifizierungen`,
    h85f4df4fdcb8beed: html `Risiko und Strategie`,
    hb6b70f369f25a7ac: html `Compliance und Ethik`,
    hc639dc8eaab7815d: html `Probleme und Berichterstellung`,
    hcd22a6d6c40d8786: html `Audit und Analyse`,
    "link-home": `Home`,
    "nav-section-home": `Home`,
    s032cd9f1245d3645: `Leerzeichen`,
    s08e6d298452e8f68: `Audit`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Fenster „Tastenkombinationen“ öffnen`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Anlagenbestand`,
    s14ba513bc8896c24: `Robots`,
    s1534ff9f453525e1: `Erste Zelle auswählen`,
    s175d37c8eb04d73e: `Downloads`,
    s1967ea0b8a2b6015: `Ausgewählte Zelle ausführen`,
    s199f5853f4e718f7: `Projekte`,
    s24761a0cc8d9c0aa: `Organisation`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Nach oben scrollen`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Fenster „Organisations-Switcher“ öffnen`,
    s2e109263b73c12d5: `Lizenzen`,
    s34d94212c9758944: `Strategie`,
    s353873ecbaa3efe9: `Pfeil nach links`,
    s3736464cf8d6fa08: `Support`,
    s392dc2954562a82b: `Texteditor`,
    s39cccc90e6fe1d7f: `Problemmanager`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Letzte Folie`,
    s3f809b62bcc2a44c: `Kontrollzentrum`,
    s45efff328e4d0a4d: `Organisatione suchen`,
    s460bf77c46d93bb4: `Fenster „Tastenkombinationen“ schließen`,
    s469437ae00d48e37: `Aktuelle Zeile erweitern`,
    s47de2481b149190a: `Entitäten`,
    s4802e47fe2e95134: `Option`,
    s480d27b7a8b69ce5: `Nach links scrollen`,
    s49ca4bf0e63593da: `Dialogfenster schließen`,
    s4b10acae683d2978: `Vollbild`,
    s4b81aa9512692c4d: `Seitennavigation ausblenden`,
    s523eb9043213ff0d: `Kursiv`,
    s56410a6c80d5215c: `Zelle nach unten verschieben`,
    s58622fa7922ed03b: `Schaltfläche „Hilfemenü“`,
    s586d6bd2eca2da93: `Benutzer`,
    s5a41c3a63f1c18af: `Profileinstellungen`,
    s5b56a21c08c842c4: `Erste Folie`,
    s5c1ecf88259b79f9: `Präsentation`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Compliance-Maps`,
    s5d929ff1619ac0c9: `Suchen`,
    s5db46d120dcba694: `Bewertungen`,
    s5e27738a2e8eb763: `Anmelden`,
    s5e8250fb85d64c23: `Schließen`,
    s5febcd9b311c16fe: `Nach rechts scrollen`,
    s60565faf8db3a5cb: `Diese und alle Zellen darüber ausführen`,
    s62bc518b503d1c76: `Zelle darunter auswählen`,
    s63b6edf663b6a3c5: `Zelle unten hinzufügen`,
    s6d5cb7af3fa87c78: `Aufgabenverfolgung`,
    s6db55a42bcb74cfc: `Problemverfolgung`,
    s6fb3409caa74b0a4: `Strg`,
    s70113bbc33303a81: `Hilfemenü`,
    s7417792bbe720149: `Wiederholen`,
    s74cb3d66f6a668e1: `Dokumentation`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Abmelden`,
    s7db511600050e797: `Diese und alle Zellen darunter ausführen`,
    s7deaf226ff8b192c: `Installationsprogramme`,
    s7e388025be643d0d: `Eingabe`,
    s7eb1e34fc5ece4cd: `Menü „Profil“`,
    s884bcdca26998a48: `Berichte`,
    s89365ba6fa5cdb97: `Ausführung beenden`,
    s89ba33f94f92f3cc: `Identifizierungskampagnen`,
    s8f4be9f086eb530f: `Rückgängig`,
    s9021935bcdd703b9: `Seitenbereich öffnen`,
    s9373ade6d85b4388: `Aktuelle Zeile reduzieren`,
    s947f21967d65c480: `Marketplace`,
    s9ab2385df7adbce0: `Zeile markieren`,
    s9dd12575273ac110: `Nach unten scrollen`,
    s9df9510d60035af3: `Menü „Profil“ öffnen`,
    s9f26843287bb592d: `Gruppen`,
    s9fda4232f5e1876a: `Hilfe`,
    sa05b93d8764f88ed: `Risikomanager`,
    sa103c8e0c776e11c: `Tastenkombinationen anfordern`,
    sa153c163bc11460d: `Activity Center`,
    sa35ed9234d3d66ce: `Keine Organisationen gefunden.`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Organisationsstruktur`,
    saed6432f1517ea10: `Asset Manager`,
    saf7a5eef69e5bb59: `Pfeil nach oben`,
    sb061ff5a347a296e: `Profil`,
    sb206d700d26b14ff: `Unterstreichen`,
    sb21cca7db5de38f3: `Storyboards`,
    sb284cd019b430d1e: `Es sind keine App-spezifischen Tastenkombinationen verfügbar.`,
    sb32c8490570a8831: `Übersicht der Folien`,
    sb4484b8d878dffff: `Aktivitätsprotokoll`,
    sb752d83c4e4619bc: str `Wechseln zu ${0}`,
    sb888017adf7992b9: `Diligent Academy`,
    sbd63362a31200ab4: `Gehe zu Launchpad`,
    sbda32dab0c54ffdd: `Nächste Folie`,
    sbf84c104b8212e06: `Zelle darüber auswählen`,
    sc203eef710f83583: `Für diese App werden keine speziellen Tastenkombinationen unterstützt.`,
    sc2873891e8c3be68: `Robots-Skript-Editor`,
    sc835e30bc3bdd2fd: `Zelle nach oben verschieben`,
    sc8aa5792985e2ba3: `Plattform-Einstellungen`,
    sca1a826088564455: `Ergebnisse`,
    sca442b5dc0fd394c: `Pfeil nach unten`,
    scdd4399eeeacd8f4: `Organisation wechseln`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Alle auswählen`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Seiten-Navigation`,
    sd1c09a62f063a73b: `Aufgabenmanager`,
    sd514ab1c93237dae: `Sicherungspläne`,
    sd76505ffae553332: `Forschungsportal`,
    sd81eecf773db25fc: `Alle Zellen sequenziell ausführen`,
    sd8f923198e0c5c6a: `Ende`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `Wir unterstützen keine speziellen Tastenkombinationen für diese App, aber wenn Sie Vorschläge haben, lassen Sie es uns bitte wissen.`,
    sdc599e1d5c823e75: `Letzte Zelle auswählen`,
    sdcc5f064d591aefd: `Vorherige Folie`,
    se2faf168207b0a48: `Frameworks`,
    se3b4c857f91f80d7: `Tastenkombinationen`,
    se65e4e6f3696e997: `Schulung`,
    se93a3eaf86201ae7: `Umschalt`,
    sed2d45e3f811c81d: `Grundlegend`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Ausgewählte Zelle löschen`,
    sf2d615b20d62225a: `Ablaufplaner`,
    sf41a0c89409353dc: `Pfeil nach rechts`,
    sf5597bb9f2103d2a: `Aktivierungen`,
    sf7c0eba7c822e3d6: `Fett`,
    sf95b10c03a2d5872: `Navigation öffnen`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Konfiguration`,
    sfc6b9ce43d2c798c: `Stundennachweise`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Pos1`,
};
